import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../../common/controller/common.service';




import {ApiMessageService} from '../../../core/api-message.service';
import {TipoEntitaOrganizzativaAttributo} from './tipoentitaorganizzativaattributo.model';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../../common/builder/json-base-builder';
import {ConfigService} from '../../../core/config.service';
import {Table} from '../../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../../app-routing.module';
import {Gerarchia} from '../../../+anagrafica/gerarchia/gerarchia.model';
import {TipoGerarchia} from '../../tipogerarchia/tipogerarchia.model';

@Injectable()
export class TipoEntitaOrganizzativaAttributoService extends CommonService<TipoEntitaOrganizzativaAttributo> {

  public static ROUTE = 'tipoentitaorganizzativaattributo';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): TipoEntitaOrganizzativaAttributo {
    return JsonBaseBuilder.jsonToTipoEntitaOrganizzativaAttributo(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return TipoEntitaOrganizzativaAttributoService.ROUTE;
  }

  public getTable(items: TipoEntitaOrganizzativaAttributo[]): Table {
    return Table.buildBaseTable(TipoEntitaOrganizzativaAttributo.getTableKeys(), items);
  }

  public existingNome(nome: string, entity: TipoEntitaOrganizzativaAttributo): Observable<boolean> {
    return this.getBoolean('/existingnome', new HttpParams()
      .set('nome', nome)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

}
